import FusesMt from "../classes/FuseMt"

export const fusesMt = [
  new FusesMt({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new FusesMt({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new FusesMt({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
